export default function() {
    return {
        survey: false,
        success: false,
        error: false,
        errorField: false,
        surveyAnswers: {
            observations: '',
            placeObservations: '',
            tripRank: 0,
            placeRank: 0,
            agencyRank: 0,
            companyRank: 0
        }
    }
}
